import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BedrijvenComponent } from "./components/bedrijven/bedrijven.component";
import { ChiptuningComponent } from "./components/chiptuning/chiptuning.component";
import { ContactComponent } from "./components/contact/contact.component";
import { HomeComponent } from "./components/home/home.component";
import { KopenVerkopenComponent } from "./components/kopen-verkopen/kopen-verkopen.component";
import { VermogensmetingComponent } from "./components/vermogensmeting/vermogensmeting.component";

const routes: Routes = [
  { path: "", component: HomeComponent },
  { path: "home", component: HomeComponent },
  { path: "contact", component: ContactComponent },
  { path: "vermogensmeting", component: VermogensmetingComponent },
  { path: "bedrijven", component: BedrijvenComponent },
  { path: "chiptuning", component: ChiptuningComponent },
  { path: "kopen-verkopen", component: KopenVerkopenComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})export class AppRoutingModule {}
